import React, { useState, useEffect, useCallback } from "react";
import { ids, styles } from "./PaymentHistoryCss";
import {
  Dimensions,
  ScrollView,
  View,
  Image,
  RefreshControl,
} from "react-native";
import AppBar from "../Layout/AppBar";
import SearchPayment from "./Search Payment/SearchPayment";
import { Text } from "react-native";
import { Button } from "react-native-paper";
import { primaryColor, subTextColor } from "../../constant/constantCss";
import PaymentHistoryTable from "./Payment Table/PaymentHistoryTable";
import { GetUserPaymentHistory } from "../../service/api/payment/api";
import { showToast } from "../../constant/toastMessage";
import noPayment from "../../../assets/icons/no_payment.png";
import PaymentFilterModal from "./Filter Modal/PaymentFilterModal";
import PlaneLoader from "../../components/Loader";

const PaymentHistory = () => {
  const PAGE_SIZE = 10;
  const { height, width } = Dimensions.get("window");
  const [loader, setLoader] = useState(false);
  const [isVisibleFilterModal, setIsVisibleFilterModal] = useState(false);
  const [paymentList, setPaymentList] = useState([]);
  const [page, setPage] = useState(0);
  const [noOfPage, setNoOfPage] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const initalCallingApi = () => {
    setLoader(true);
    GetUserPaymentHistory({ page: page + 1 })
      .then((res) => {
        setLoader(false);
        setPaymentList(res.data?.results);
        setNoOfPage(Math.ceil(res?.data?.count / PAGE_SIZE));
      })
      .catch((err) => {
        setLoader(false);
        showToast("error", err?.response?.data?.detail);
      });
  };
  const onRefresh = useCallback(() => {
    setRefreshing(true);
    setTimeout(() => {
      initalCallingApi();
      setRefreshing(false);
    }, 1000);
  }, []);

  useEffect(() => {
    initalCallingApi();
  }, [page]);

  return (
    <View style={[styles.container, { minHeight: height }]}>
      <AppBar />
      <ScrollView
        showsVerticalScrollIndicator={false}
        refreshControl={
          <RefreshControl
            refreshing={refreshing}
            onRefresh={onRefresh}
            tintColor={primaryColor}
            colors={[primaryColor]}
          />
        }
      >
        <View style={styles.subContainer}>
          <View style={styles.flexRow}>
            <Text style={styles.headingText}>Payment History</Text>
          </View>
          {loader ? (
            <PlaneLoader />
          ) : (
            <React.Fragment>
              <View style={styles.flexRow}>
                <SearchPayment setPaymentList={setPaymentList} />
                <Button
                  mode="outlined"
                  icon={"filter"}
                  textColor={subTextColor}
                  style={{ borderRadius: 10 }}
                  onPress={() => {
                    setIsVisibleFilterModal(true);
                  }}
                >
                  {width >= 480 && "Filter"}
                </Button>
              </View>
              {paymentList?.length > 0 ? (
                <PaymentHistoryTable
                  paymentList={paymentList}
                  page={page}
                  setPage={setPage}
                  noOfPage={noOfPage}
                />
              ) : (
                // payment not found view
                <View
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 20,
                    alignItems: "center",
                  }}
                >
                  <Image
                    source={noPayment}
                    resizeMode={"contain"}
                    style={{ height: 100, width: 100 }}
                  ></Image>
                  <Text style={{ fontSize: 18, fontWeight: 600 }}>
                    Payment Not Found!
                  </Text>
                </View>
              )}
            </React.Fragment>
          )}
        </View>
      </ScrollView>
      {isVisibleFilterModal && (
        <PaymentFilterModal
          visible={isVisibleFilterModal}
          handleClose={() => setIsVisibleFilterModal(false)}
          setPaymentList={setPaymentList}
        />
      )}
    </View>
  );
};

export default PaymentHistory;
